import { Box, BoxProps } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import React from 'react';

const shimmer = keyframes`
  0% { background-position: -300% 0; }
  100% { background-position: 300% 0; }
`;

interface ShimmerLoadingBarProps {
  w: string | number;
  h?: string | number;
  containerStyles?: BoxProps;
}

export const ShimmerLoadingBar: React.FC<ShimmerLoadingBarProps> = ({
  w,
  h = '10px',
  containerStyles,
}) => (
  <Box
    w={w}
    h={h}
    borderRadius="full"
    position="relative"
    overflow="hidden"
    bgGradient="linear-gradient(270deg, rgba(255, 255, 255, 0.3) 0%, rgba(138, 144, 255, 0.3) 54%, rgba(177, 95, 218, 0.3) 80%)"
    {...containerStyles}
  >
    <Box
      position="absolute"
      top={0}
      left={0}
      w="100%"
      h="100%"
      bgGradient="linear(90deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 100%)"
      backgroundSize="200px 100%"
      backgroundRepeat="no-repeat"
      animation={`${shimmer} 2s infinite ease-in-out`}
      pointerEvents="none"
    />
  </Box>
);
